<template>
  <widget-template title="Claims Status Summary">
    <div slot="title">
      <div>
        <div class="headline">Claims Status Summary</div>
        <span class="grey--text">{{ myClaimsSummaryChart.info }}</span>
      </div>
    </div>
    <div>
      <span class="pr-2 pl-2">
        <v-menu offset-y :max-height="300">
          <div v-on="on">
            <v-tooltip top>
              <v-layout align-center v-on="on"> <v-icon>mdi-calendar-today</v-icon> {{ selectedScope.description }} </v-layout>
              <span>{{ selectedScope.info }}</span>
            </v-tooltip>
          </div>
          <v-list>
            <v-list-item v-for="(option, key) in scopes" :key="key" @click="doSelectScope(key)">
              <v-list-item-title>{{ option.description }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </span>
      |
      <span class="pr-2 pl-2">
        <v-menu offset-y :max-height="300">
          <div v-on="on">
            <v-tooltip top>
              <v-layout align-center v-on="on"> <v-icon>mdi-view-grid</v-icon> {{ selectedAppId.description }} </v-layout>
              <span>
                {{ permittedAppIdsText }}
              </span>
            </v-tooltip>
          </div>
          <v-list>
            <v-list-item v-for="(appId, index) in appIds" :key="index" @click="doSelectAppId(appId.id)">
              <v-list-item-title>{{ appId.description }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </span>
    </div>
    <div class="mt-4" style="position: relative">
      <v-layout>
        <v-flex lg12 md12 xs12>
          <v-card class="mt-4 mx-auto" max-width="520">
            <v-sheet class="v-sheet--offset mx-auto" color="green" elevation="6" max-width="calc(100% - 32px)">
              <chartist ratio="ct-major-tenth" type="Pie" :data="ctData" :options="ctOptions" :responsiveOptions="responsiveOptions"> </chartist>
            </v-sheet>
            <v-card-text class="pt-0">
              <div class="subheading font-weight-light grey--text">For the past 10 days</div>
              <v-divider class="my-2"></v-divider>
              <div slot="action">
                <div v-if="initState === 0">
                  <v-tooltip bottom>
                    <span v-on="on" class="grey--text">
                      <v-icon small color="orange">mdi-record</v-icon>
                      Loading...
                    </span>
                    <span>Loading</span>
                  </v-tooltip>
                </div>
                <div v-else-if="initState === 1">
                  <v-tooltip bottom>
                    <div v-on="on" @click="doReload" class="widgetAction grey--text">
                      <v-icon small>mdi-refresh</v-icon>
                      Updated {{ lastUpdated }} ago
                    </div>
                    <span>Click to update</span>
                  </v-tooltip>
                </div>
                <div v-else>
                  <v-tooltip bottom>
                    <span v-on="on" @click="doReload" class="widgetAction grey--text">
                      <v-icon small color="red">mdi-record</v-icon>
                      Error
                    </span>
                    <span>Click to retry</span>
                  </v-tooltip>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </widget-template>
</template>

<script>
import { mapActions } from 'vuex'
import { formatDisplayTimeDistance } from '@/utils/date'
import { longScopeMixin } from '../longScopeMixin'

export default {
  data() {
    return {
      widgetForm: {
        scope: 'days',
        appId: 'all'
      },
      ctData: {},
      ctOptions: {
        labelInterpolationFnc: function (value) {
          return value[0]
        }
      },
      responsiveOptions: [
        [
          'screen and (min-width: 640px)',
          {
            chartPadding: 15,
            labelOffset: 40,
            labelDirection: 'explode',
            labelInterpolationFnc: function (value) {
              return value
            }
          }
        ],
        [
          'screen and (min-width: 1024px)',
          {
            labelOffset: 40,
            chartPadding: 10
          }
        ]
      ]
    }
  },
  watch: {
    'myClaimsSummaryChart.chartInfo': function (value) {
      this.compileData(value)
    }
  },
  computed: {
    myClaimsSummaryChart() {
      return this.$store.state.widgets.myClaimsSummaryChart
    },
    initState() {
      return this.myClaimsSummaryChart.init
    },
    lastUpdated() {
      return formatDisplayTimeDistance(this.myClaimsSummaryChart.lastUpdated, this.timeNow)
    },
    permittedAppIdsText() {
      return this.formatPermitAppIdsText(this.myClaimsSummaryChart.appIds)
    }
  },
  methods: {
    ...mapActions(['initMyClaimsSummaryChart']),
    doReload() {
      // Combine Form
      this.widgetForm.scope = this.scopeForm.scope
      this.widgetForm.appId = this.appIdForm.appId
      this.initMyClaimsSummaryChart(this.widgetForm)
    },
    compileData(value) {
      // console.log(value[0].cData)
      this.ctData = value[0].cData
    }
  },
  mounted() {
    if (this.initState !== 1) {
      // Default values
      this.doSelectScope('days', false)
      this.doSelectAppId('all')
    } else {
      // Doesnt want to do auto refresh here (save bandwidth, let user do it manually)
      if (this.myClaimsSummaryChart.scope) {
        this.doSelectScope(this.myClaimsSummaryChart.scope, false)
      }
      if (this.myClaimsSummaryChart.appId) {
        this.doSelectAppId(this.myClaimsSummaryChart.appId, false)
      }
      // compile data
      this.compileData(this.myClaimsSummaryChart.chartInfo)
    }
  },
  mixins: [longScopeMixin()]
}
</script>

<style lang="scss">
@import 'chartist/dist/scss/chartist.scss';
.v-sheet {
  border-radius: 4px !important;
}
.v-sheet--offset {
  top: -24px;
  position: relative;
}
.v-card--material-stats.v-card .v-offset .v-card {
  max-width: 85px;
  max-height: 85px;
  line-height: 85px;
  padding: 15px !important;
}
.ct-series-a .ct-line {
  /* Set the colour of this series line */
  stroke: #e5e5e5;
}
.ct-series-a .ct-point {
  /* Colour of your points */
  stroke: #e5e5e5;
}
.ct-series-a .ct-bar {
  /* Colour of your bars */
  stroke: #e5e5e5;
}
.ct-label {
  fill: #e5e5e5 !important;
  color: #e5e5e5 !important;
  font-size: 0.75rem;
  line-height: 1;
}
.ct-series-a .ct-slice-pie {
  fill: rgb(50, 165, 241);
  stroke: #e5e5e5;
  stroke-width: 2px;
}
</style>
